import CompleteUserInfoBanner from './CompleteUserInfoBanner';

export default CompleteUserInfoBanner;
